import NotificationMixin from './NotificationMixin';

export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
  },
  mixins: [NotificationMixin],
  data() {
    return {
      options: [
        {
          endpoint: '', // e.g. () => this.$api.companies.list()
          optionsFieldName: '', // Options data object e.g. this.companies, can also be a callback that refers to an
          // object which has a 'options' field. e.g. () => this.multipleThings[3] which contains { options: [] }
          nameFieldName: '', // Field name that is as the label (name), this can be a callback that passes the row
          // as a parameter
          idFieldName: '', // ID Field name that is on the model, typically a FK
          externalIdFieldName: '', // ID Field name that is on the incoming model, typically a PK
          additionalFields: [], // Additional fields to include in the object
          modelArrayName: '', // Mainly for many to many relationships, this is the model field name which holds all
          idIsString: false, // If the id is a string. Useful for UUIDs
          // the pivots e.g. coverholders: {}
        }
      ],
      internalLoading: false,
      optionsLoaded: false,
      formReferences: [
        'form',
      ],
      additiveForms: [],
      multiReferencesCompleted: [],
    };
  },
  computed: {
    busy() {
      return this.loading || this.internalLoading;
    },
    isEdit() {
      return typeof this.value.id !== 'undefined';
    }
  },
  watch: {
    model: {
      handler(newValue) {
        this.$emit('input', newValue);
      },
      immediate: true,
      deep: true,
    },
    'value.id': {
      handler(newValue, oldValue) {
        if (newValue) {
          this.model = this.value;

          // We only want to set the objects once the options are actually loaded
          const i = setInterval(async () => {
            if (this.optionsLoaded) {
              clearInterval(i);
              await this.setModelReferencesToObjects();
            }
          }, 150)
        }
      },
      immediate: true,
    },
  },
  async created() {
    await this.loadOpts();
  },
  methods: {
    async loadOption(endpointFn = null, nameForOptions, nameForField, externalIdFieldName, additionalFields = []) {
      try {
        if (!endpointFn) {
          return;
        }

        const {data} = await endpointFn();

        const mapData = () => data.data.map((i) => {
          if (!i) {
            return;
          }

          let fieldName = i[nameForField];
          // Allow for callback fn
          if (typeof nameForField === 'function') {
            fieldName = nameForField(i);
          }

          let idField = i.id;
          if (externalIdFieldName) {
            idField = i[externalIdFieldName];
          }

          const result = {
            id: idField,
            name: fieldName
          };

          additionalFields.forEach((field) => result[field] = i[field]);

          return result
        });

        if (typeof nameForOptions !== 'function') {
          this.$set(this, nameForOptions, mapData());
          return;
        }

        if (Array.isArray(nameForOptions)) {
          nameForOptions.length = 0;
          nameForOptions.push(...mapData());
          return;
        }

        const options = nameForOptions();
        options.options = mapData();
      } catch (e) {
        console.log(e);
      }
    },
    async loadOpts() {

      this.optionsLoaded = false;
      this.internalLoading = true;

      await this.preOptions();

      // Load options into an array
      const opts = this.options.map(({endpoint, optionsFieldName, nameFieldName, externalIdFieldName, additionalFields = []}) =>
        this.loadOption(endpoint, optionsFieldName, nameFieldName, externalIdFieldName, additionalFields));

      await Promise.all(opts);

      this.optionsLoaded = true;
      this.internalLoading = false;
    },
    async preOptions() {},
    async preModelReferences(){},
    processPivotData(fieldName, nameForOptions, modelArrayName, modelArray) {
      modelArray.forEach((row, index) => {
        // Most rows come with a 'pivot', but once we have done this once we replace the row with the pivot info
        const pivotData = row.pivot ? row.pivot : row;
        // The pivot data is the valuable stuff here
        const idKey = pivotData[fieldName];
        // We do what we are doing for a single item, get the id from the options
        const refObj = this[nameForOptions].find(({id}) => parseInt(id) === parseInt(idKey));

        // Set the pivot item id key along with pivot data

        // Trigger the change
        const currentArrayItem = this.model[modelArrayName][index];
        let newObjectItem = {
          ...currentArrayItem, // The current value
          [fieldName]: refObj ? refObj : null,
        };

        // The first time we are making it
        const multiReferenceId = modelArrayName + index;
        if (!this.multiReferencesCompleted.includes(multiReferenceId)) {
          newObjectItem = {
            ...pivotData,
            [fieldName]: refObj ? refObj : null,
          }
        }

        this.$set(this.model[modelArrayName], index, newObjectItem);

        this.multiReferencesCompleted.push(multiReferenceId);
      })
    },
    processModelArrayReference(fieldName, nameForOptions, modelArrayName, childModelArrayName = null, model = this.model) {
      if (modelArrayName && model[modelArrayName]) {
        // If the field is an array, we are working with a many to many most likely

        const modelArray = model[modelArrayName];

        if (Array.isArray(modelArray)) {
          // Get each 'pivot' from each row
          modelArray.forEach((row, index) => {
            if (childModelArrayName) {
              return this.processModelArrayReference(
                fieldName,
                nameForOptions,
                childModelArrayName,
                null,
                model[modelArrayName][index]
              );
            }

            // Most rows come with a 'pivot', but once we have done this once we replace the row with the pivot info
            const pivotData = row.pivot ? row.pivot : row;
            // The pivot data is the valuable stuff here
            const idKey = pivotData[fieldName];
            // We do what we are doing for a single item, get the id from the options
            const refObj = this[nameForOptions].find(({id}) => parseInt(id) === parseInt(idKey));
    
            // Set the pivot item id key along with pivot data
    
            // Trigger the change
            const currentArrayItem = model[modelArrayName][index];
            let newObjectItem = {
              ...currentArrayItem, // The current value
              [fieldName]: refObj ? refObj : null,
            };
    
            // The first time we are making it
            const multiReferenceId = modelArrayName + index;
            if (!this.multiReferencesCompleted.includes(multiReferenceId)) {
              newObjectItem = {
                ...pivotData,
                [fieldName]: refObj ? refObj : null,
              }
            }
    
            this.$set(model[modelArrayName], index, newObjectItem);
    
            this.multiReferencesCompleted.push(multiReferenceId);
          })

          return true;
        }

        const obj = model[modelArrayName][fieldName];

        const refObj = this[nameForOptions].find(({id}) => parseInt(id) === parseInt(obj));

        this.$set(model[modelArrayName], fieldName, refObj);
      }
    },
    async loadModelReferenceIntoObject(fieldName, nameForOptions, modelArrayName = null, idIsString = false) {
      if (modelArrayName) {
        let arrayName = null;
        let childArrayName = null;

        if (modelArrayName.includes(".")) {
          const arrayNames = modelArrayName.split(".");
          arrayName = arrayNames[0];
          childArrayName = arrayNames[1];
        } else {
          arrayName = modelArrayName;
        }

        this.processModelArrayReference(fieldName, nameForOptions, arrayName, childArrayName);
      }
      
      if (!this.model[fieldName]) {
        return true;
      }
    
      const obj = this.model[fieldName];
      let refObj = this[nameForOptions].find(({id}) => parseInt(id) === parseInt(obj));
    
      if (idIsString) {
        refObj = this[nameForOptions].find(({id}) => id === obj);
      }
    
      if (refObj === undefined) {
        console.warn(`Reference object not found for field: ${fieldName}`);
      }

      this.model[fieldName] = refObj !== undefined ? refObj : null;
    },
    async setModelReferencesToObjects() {
      this.internalLoading = true;

      await this.preModelReferences();

      this.multiReferencesCompleted = [];
      const fillAllOptions = async () => {
        this.options.forEach(({idFieldName, optionsFieldName, modelArrayName = null, idIsString = false}) => {
          if (Array.isArray(idFieldName)) {
            idFieldName.forEach((field) => this.loadModelReferenceIntoObject(field, optionsFieldName, modelArrayName, idIsString));
          } else {
            this.loadModelReferenceIntoObject(idFieldName, optionsFieldName, modelArrayName, idIsString);
          }
        });
      }

      await fillAllOptions();
      await this.postOptions();

      this.internalLoading = false;
    },
    async postOptions() {},
    /**
     * Validate the form. Returns a boolean
     * @returns {boolean}
     */
    validate() {
      const validateArrayForms = (formElement) => {
        // Default is that we are validated.
        let valid = true;

        if (formElement) {
          // Get all field array elements
          const vfgs = formElement.$children
              .filter((c) => c.$el.className.includes('field-array'))
              .map((c) => c.$children[0]);

          // For each field array field type, get the vfg root (field-object) and validate
          vfgs.forEach((c) => {
            c.$children.forEach(async (o) => {
              const vfg = o.$children[0];

              // Recursively check sub array forms too.
              if (!(vfg.validate() && validateArrayForms(vfg))) {
                valid = false;
              }
            });
          });
        }

        return valid;
      };

      let isValid = true;

      this.formReferences.forEach((ref) => {
        let localIsValid = isValid;

        if (this.$refs[ref] && !this.$refs[ref].validate()) {
          localIsValid = false;
        }

        // Validate field-arrays
        if (!validateArrayForms(this.$refs[ref])) {
          localIsValid = false;
        }

        // If the validation has already failed, we want to preserve that state
        if (!isValid) {
          return isValid;
        }

        isValid = localIsValid
      })

      if (this.additiveForms && this.additiveForms.length) {
        this.additiveForms.forEach((ref) => {
          let localIsValid = isValid;

          if (this.$refs[ref]) {
            if (!this.$refs[ref].$refs.additiveForm.validate()) {
              localIsValid = false;
            }

            // Validate field-arrays
            if (!validateArrayForms(this.$refs[ref].$refs.additiveForm)) {
              localIsValid = false;
            }
          }

          // If the validation has already failed, we want to preserve that state
          if (!isValid) {
            return isValid;
          }

          isValid = localIsValid;
        })
      }

      if (!isValid) {
        this.notifyMissingFields();
      }

      return isValid;
    }
  },
};
